// This file was generated by lezer-generator. You probably shouldn't edit it.
import {LRParser} from "@lezer/lr"
import {jsTemplateHighlight} from "./highlight"
export const parser = LRParser.deserialize({
  version: 14,
  states: "%|OQOPOOOfOPO'#CbO!`OPO'#C^OOOO'#Cu'#CuOOOO'#Ch'#ChO!xOPO'#CbOOOO'#Cj'#CjOOOO'#Cc'#CcQQOPOOOOOO,58y,58yO#SOPO'#C_O#jOPO'#CpO$SOPO'#CsOOOO'#Co'#CoO$ZOPO'#CtOOOO'#Cd'#CdO$lOPO'#C`O$sOPO,58xOOOO-E6f-E6fOOOO-E6a-E6aOOOO'#Ce'#CeO$xOPO,59[OOOO,59[,59[OOOO'#Cf'#CfO%POPO,59_OOOO,59_,59_OOOO'#Cg'#CgO%WOPO,59`OOOO,59`,59`OOOO-E6b-E6bOOOO'#Ca'#CaOOOO1G.d1G.dOOOO-E6c-E6cOOOO1G.v1G.vOOOO-E6d-E6dOOOO1G.y1G.yOOOO-E6e-E6eOOOO1G.z1G.z",
  stateData: "%i~O_RO`ROaPObROeROfRO~O`XO]UX_UXaUXbUXeUXfUX~O`^OaYOb_OeZOf[O~O_SP~P}O_RO`RObROeROfRO~O]UXaUX~P!gO`XO~O_dO`dOadObdOfdO~OefO~P#XO_gO`gOagObgOegO~OfiO~P#qO_lO`^ObjOejOfjO~O_SX~P}O_nO~OeqO~P#XOfsO~P#qO_uO`^ObjOejOfjO~O",
  goto: "#ajPPksy|!P!T!Z!a!g!m!sP!zPPPPo#OPP#O#S#[SUOWT_Q`XQOQW`RaQRoaTUOWQWORcWQ`QRm`QeZRpeQh[RrhQk^RtkSTOWRbTTVOWT]Q`S_Q`Tj^kVSOTW",
  nodeNames: "⚠ Template TemplateExpr TemplateStart TemplateContent TemplateEnd Text",
  maxTerm: 25,
  propSources: [jsTemplateHighlight],
  skippedNodes: [0],
  repeatNodeCount: 6,
  tokenData: "!p~R]Orzrs!Pstztu!Uuwzwx!Zx#oz#o#p!`#p#qz#q#r!e#r;'Sz;'S;=`!j<%lOz~!POb~~!UOe~~!ZOa~~!`Of~~!eO`~~!jO_~~!mP;=`<%lz",
  tokenizers: [0],
  topRules: {"Template":[0,1]},
  tokenPrec: 0
})
